var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    fillRule: "evenodd",
    d: "M8 2.501A5.999 5.999 0 1 0 8 14.5 5.999 5.999 0 0 0 8 2.5M.665 8.5a7.335 7.335 0 1 1 14.67 0 7.335 7.335 0 0 1-14.67 0m6.667-4.001h1.343v1.336H7.332zm1.336 2.666v5.336H7.332V7.165z",
    clipRule: "evenodd"
  })));
};
export default SvgInformationCircle;